// src/components/ElectionList.jsx
import React, { useEffect, useState } from "react";
import { useAuth } from "@clerk/clerk-react";
import { getAllElections } from "../services/ElectionService";

export default function ElectionList() {
    const { getToken } = useAuth();
    const [elections, setElections] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const token = await getToken();
                const data = await getAllElections(token);
                setElections(data);
            } catch {
                // error already toasted
            }
        })();
    }, [getToken]);

    return (
        <div>
            <h2>All Elections</h2>
            <ul>
                {elections.map((e) => (
                    <li key={e.id}>{e.name} on {e.electionDate}</li>
                ))}
            </ul>
        </div>
    );
}
